<template>
  <section class="section is-bg-white pb-0 pt-0">
    <div class="container">
      <div class="columns is-mobile is-multiline pageContent is-variable is-8">
        <!-- main content -->
        <!-- sidebar -->
        <div class="column is-8">
          <div>
            <button
              v-if="!isDownloadingAll"
              aria-label="Download All"
              class="button is-brightGreen"
              @click="downloadAllRawdata"
            >
              <label>{{ $t('rawdata.button.downloadAll') }}</label>
            </button>
            <button
              v-else
              class="button disabled"
              aria-label="Download disabled"
            >
              <label>{{ $t('rawdata.button.downloading') }}</label>
            </button>
          </div>
          <div
            v-show="downloadAllLink.href"
            class="m-2"
          >
            <p>{{ $t('rawdata.tabs.tab3.manualDownloadMsg') }}</p>
            <a
              ref="linkElement"
              class="download-button button mt-1"
              download
              target="_blank"
              :href="downloadAllLink.href"
              aria-label="download all"
            >{{ $t('rawdata.button.downloadResult', { fileSize: downloadAllLink.fileSize}) }}</a>
          </div>
        </div>
        <div class="column is-4">
          <div class="h4 pb-3">
            {{ $t('rawdata.sideHeader') }}
          </div>
          <div v-html="$t('rawdata.sideDescription')" />
        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
import { rawdataState } from '@/composables/state/rawdataApp';
import { reactive, ref } from 'vue';
// import DataSummaryViewVue from './DataSummaryView.vue';

const {
  allParams,
  downloadRawdata
} = rawdataState();

const isDownloadingAll = ref(false);
const downloadAllLink = reactive({ href: '', fileSize: '' });
const linkElement = ref(null);

const downloadAllRawdata = () => {
  downloadRawdata(allParams.value, isDownloadingAll, downloadAllLink);
};
</script>
<style scoped>
@media screen and (max-width: 840px) and (min-width:768px) {  /* Adjust based on your layout and tooltip size */
  .column.is-3-tablet {
    width: 100%;
  }
}

</style>
